import { ResizeObserver } from '@juggle/resize-observer';
import { IImageMasonry } from '@models/IImageMasonry';
import ImageMasonryItem from '@molecules/ImageMasonryItem/ImageMasonryItem';
import useMasonryLayout from '@utils/hooks/useMasonryLayout';
import classNames from 'classnames';
import { useRef } from 'react';
import useMeasure from 'react-use-measure';

const ImageMasonry = ({ images, language }: IImageMasonry) => {
  // Pollyfill is for storybook only, but it will get bundled into the output bundle sooo
  const [columnSizerRef, columnSizerBounds] = useMeasure({
    polyfill: ResizeObserver,
  });
  const masonryContainerRef = useRef<HTMLDivElement>(null);
  const columnSizerClassName = 'grid-sizer';
  const itemClassName = 'grid-item';
  const gutter = 16;

  useMasonryLayout(masonryContainerRef, {
    columnWidth: `.${columnSizerClassName}`,
    itemSelector: `.${itemClassName}`,
    gutter,
    horizontalOrder: true,
  });

  return (
    <div className="container" data-testid="Image-Masonry">
      <div
        ref={masonryContainerRef}
        style={
          {
            '--masonry-gutter': `${gutter}px`,
          } as React.CSSProperties
        }
      >
        <div ref={columnSizerRef} className={columnSizerClassName} />

        {images.map((cameraImage, index) => (
          <ImageMasonryItem
            {...cameraImage}
            key={`${cameraImage.image?.desktop?.url}-masonry-item`}
            className={classNames(itemClassName, {
              [`${itemClassName}--large-size`]: index === 1,
            })}
            isDoubleSize={index === 1}
            gap={gutter}
            language={language}
            width={columnSizerBounds.width}
            contentIds={images.map(({ meta }) => meta?.contentLink as string)}
            dataTestId={`Image-Masonry-Item-${index}`}
          />
        ))}
      </div>
    </div>
  );
};

export default ImageMasonry;
